import React, { PropTypes } from 'react';
import RichTextEditor from 'react-rte';
import UiComponent from '../UiComponent';

export default class Wysisyg extends UiComponent {
  static propTypes = {
    field: PropTypes.object,
    onChange: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: RichTextEditor.createEmptyValue(),
      valueIsSet: false
    }
    this.changeValue = this.changeValue.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // Initial setup workaround.
    // Reprodusible issue happens only for the first time user navigates to a page.
    // The navigation MUST be done with the Browser refresh (e.g. clicking F5), otherwise it is not reproducible.
    if (nextProps.field && nextProps.field.value && !this.state.valueIsSet) {
      this.setState({
        value: RichTextEditor.createValueFromString(nextProps.field.value, 'html'),
        valueIsSet: !!nextProps.field.value
      });
    }
  }

  componentDidMount() {
    this.setState({
      value: this.props.field.value ?
        RichTextEditor.createValueFromString(this.props.field.value, 'html') :
        RichTextEditor.createEmptyValue()
    })
  }

  changeValue(value) {
    this.props.field.value = value.toString('html');
    if (this.props.relatedTo && this.props.relatedTo.length > 0) {
      this.props.onChange([
          this.props.relatedTo,
          this.props.field.name,
        ],
        this.props.field
      );
    } else {
      this.props.onChange(this.props.field.name, this.props.field);
    }
    this.setState({value});
  }

  render () {
    return (
      <div>
        {this.getLabel()}
        <RichTextEditor
          value={this.state.value}
          onChange={this.changeValue}
          disabled={this.props.disabled}
        />
        {this.getErrors()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/Wysisyg/index.js